/* onezerofive — the wordmark drawn stroke by stroke from the font's own outlines.
   Ported from the prototype; the glyph data lives in wordmark-glyphs.js. */
(function(){
  const WMG = window.OZ_WORDMARK_GLYPHS || {};
  function wordmark(svg, play){
  const NS='http://www.w3.org/2000/svg', el=(n,a={})=>{const e=document.createElementNS(NS,n);for(const k in a)e.setAttribute(k,a[k]);return e;};
  const EASE='cubic-bezier(.2,.7,.2,1)', EIO='cubic-bezier(.65,0,.35,1)';
  const byWord=w=>WMG.glyphs.filter(g=>g.word===w);
  const oGeom=g=>{const [o,i,d]=g.contours.map(c=>c.b);const cx=(o[0]+o[2])/2,cy=(o[1]+o[3])/2,ro=(o[2]-o[0])/2,ri=(i[2]-i[0])/2;return{cx,cy,r:(ro+ri)/2,sw:ro-ri,rd:(d[2]-d[0])/2};};
  const one=byWord('one'), zero=byWord('zero'), five=byWord('five'), oz=oGeom(zero[3]), oo=oGeom(one[0]);
  const g=el('g'); svg.appendChild(g);
  const path=gl=>{const p=el('path',{d:gl.contours.map(c=>c.d).join(' ')});g.appendChild(p);return p;};
  if(!play){ WMG.glyphs.forEach(path); return; }
  const anim=(n,kf,o)=>n.animate(kf,Object.assign({fill:'both',easing:EASE},o));
  anim(g,[{transform:`translate(${WMG.total/2-oz.cx}px,0)`},{transform:'translate(0,0)'}],{duration:5200,easing:EIO});
  const dot=el('circle',{class:'dot',cx:oz.cx,cy:oz.cy,r:oz.rd}); g.appendChild(dot);
  anim(dot,[{transform:'scale(0)'},{transform:'scale(1)'}],{duration:700,easing:'cubic-bezier(.2,.8,.2,1)'});
  const ring=el('circle',{class:'ring',cx:oz.cx,cy:oz.cy,r:oz.r,fill:'none','stroke-width':oz.sw}); g.appendChild(ring);
  anim(ring,[{r:oz.rd,strokeWidth:0,opacity:0},{opacity:1,offset:.15},{r:oz.r,strokeWidth:oz.sw}],{duration:900,delay:550,easing:EIO});
  ['r','e','z'].forEach((ch,k)=>{const gl=zero[2-k];const p=path(gl);anim(p,[{opacity:0,transform:`translate(${oz.cx-(gl.b[0]+gl.b[2])/2}px,0)`},{opacity:1,transform:'translate(0,0)'}],{duration:750,delay:1350+k*140});});
  const clip=el('clipPath',{id:'wmclip'}); clip.appendChild(el('rect',{x:-4000,y:-6000,width:zero[0].b[0]-120+4000,height:9000})); svg.appendChild(clip);
  const wrap=el('g',{'clip-path':'url(#wmclip)'}); g.appendChild(wrap); const oneG=el('g'); wrap.appendChild(oneG);
  one.forEach(gl=>oneG.appendChild(el('path',{d:gl.contours.map(c=>c.d).join(' ')})));
  anim(oneG,[{transform:`translate(${zero[0].b[0]-one[0].b[0]}px,0)`},{transform:'translate(0,0)'}],{duration:900,delay:2150,easing:EIO});
  const dotOne=el('circle',{class:'dot',cx:oo.cx,cy:oo.cy,r:oo.rd}); g.appendChild(dotOne);
  anim(dotOne,[{opacity:0},{opacity:0,offset:.99},{opacity:1}],{duration:3050});
  const fx0=five[0].b[0], fx1=five[3].b[2], xs=[1,3,5].map(k=>fx0+(fx1-fx0)*k/6);
  const dots3=xs.map((x,k)=>{const c=el('circle',{class:'dot',cx:x,cy:oz.cy,r:oz.rd});g.appendChild(c);anim(c,[{transform:'scale(0)'},{transform:'scale(1)'}],{duration:450,delay:3100+k*160,easing:'cubic-bezier(.2,.8,.2,1)'});return c;});
  [[oo.cx,oo.cy,dotOne],[oz.cx,oz.cy,dot],...xs.map((x,k)=>[x,oz.cy,dots3[k]])].forEach(([x,y,node],k)=>{
    const tt=3800+k*230, rip=el('circle',{class:'pulse',cx:x,cy:y,r:oz.rd,fill:'none','stroke-width':14}); g.appendChild(rip);
    anim(rip,[{opacity:0,r:oz.rd},{opacity:.9,offset:.1},{opacity:0,r:oz.rd*7}],{duration:700,delay:tt,easing:'cubic-bezier(.2,.7,.3,1)'});
    anim(node,[{transform:'scale(1)'},{transform:'scale(1.7)',offset:.35},{transform:'scale(1)'}],{duration:520,delay:tt,composite:'accumulate'});
  });
  dots3.forEach((c,k)=>anim(c,[{transform:'scale(1)',opacity:1},{transform:'scale(0)',opacity:0}],{duration:500,delay:5050+k*60,easing:EIO,fill:'forwards'}));
  five.forEach((gl,k)=>{const p=path(gl);anim(p,[{opacity:0,transform:'translate(0,40px)'},{opacity:1,transform:'translate(0,0)'}],{duration:800,delay:5150+k*90});});
}

  /* The full draw runs once per browsing session. It is six seconds of held
     attention: right the first time somebody arrives, an obstacle on the third
     visit back to the home page — and the brief is explicit that nobody should
     wait through an intro to enter the site. Returning within the session gets
     the wordmark already drawn and the category words at their normal .25s.
     Session storage can throw in private windows, hence the try/catch. */
  function seen(){
    try { if(sessionStorage.getItem('oz:intro') === '1') return true; } catch(e){}
    /* a back navigation is a return, not an arrival — never draw on one */
    const n = (performance.getEntriesByType('navigation') || [])[0];
    return !!(n && n.type === 'back_forward');
  }
  function mark(){ try { sessionStorage.setItem('oz:intro','1'); } catch(e){} }

  function start(force){
    const centre = document.getElementById('centre'); if(!centre || !WMG.glyphs) return;
    const svg = centre.querySelector('.wm svg'); if(!svg) return;
    /* the artwork sets the frame — rebuild the logo and the box follows */
    if(WMG.viewBox) svg.setAttribute('viewBox', WMG.viewBox);
    svg.innerHTML = '';
    const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* the coming-soon page is the whole of what a visitor gets — it always draws */
    const always = centre.dataset.intro === 'always';
    const play = !still && (force || always || !seen());
    if(play){ centre.classList.add('intro'); mark(); }
    else centre.classList.add('quiet');   // no draw, but it should still arrive rather than appear
    wordmark(svg, play);
    if(play) document.dispatchEvent(new CustomEvent('oz:intro'));
  }
  window.OZ = window.OZ || {};
  window.OZ.replayIntro = function(){
    const centre = document.getElementById('centre'); if(!centre) return;
    centre.classList.remove('intro'); void centre.offsetWidth; start(true);
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
